<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Reporte de cuadre de tarjetas</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="mostrarHistoricos" class="btn-secondary">
            <i class="fa fa-history"></i><span>Historial</span>
          </button>
          <button
            type="button"
            @click="exportarDocumento('E')"
            class="btn-success"
          >
            <i class="fa fa-file-excel-o"></i><span>Excel</span>
          </button>
          <button
            type="button"
            @click="exportarDocumento('P')"
            class="btn-danger"
          >
            <i class="fa fa-file-pdf-o"></i><span>PDF</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card mb-2">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-8">
            <div class="form-inline">
              <label>
                <input v-model="form.tipoFecha" type="radio" value="H" />
                <span>Hoy</span>
              </label>
              <label>
                <input v-model="form.tipoFecha" type="radio" value="A" />
                <span>Ayer</span>
              </label>
              <label>
                <input v-model="form.tipoFecha" type="radio" value="P" />
                <span>Personalizado</span>
              </label>
              <div class="form-field" v-show="form.tipoFecha == 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    v-model="form.fechaDesde"
                    locale="es"
                    only-date
                    no-label
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione fecha..."
                  />
                  <label>Desde:</label>
                </div>
              </div>
              <div class="form-field" v-show="form.tipoFecha == 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    v-model="form.fechaHasta"
                    locale="es"
                    only-date
                    no-label
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione fecha..."
                  />
                  <label>Hasta:</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div
              class="form-field select2 select2-field--stretch"
              :class="{ 'select2--disabled': !administraTodasBodegas }"
            >
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @input="inputBodega"
                  label="descripcion"
                  placeholder="Seleccione..."
                  :options="optionsBodegas"
                  id="bodegas"
                  v-model="selectedBodega"
                ></v-select>
                <label for="bodegas">Sucursal:</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3 mt-2">
            <div class="form-inline">
              <label>
                <input v-model="form.tipoValores" type="radio" value="C" />
                <span>Cantidades</span>
              </label>
              <label>
                <input v-model="form.tipoValores" type="radio" value="M" />
                <span>Montos</span>
              </label>
            </div>
          </div>
          <div class="col-xs-12 col-md-9">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @search="onSearchRutas"
                  @input="inputRutas"
                  label="nombre"
                  placeholder="Seleccione..."
                  :options="optionsRutas"
                  id="rutas"
                  v-model="selectedRutas"
                  multiple
                ></v-select>
                <label for="rutas">Rutas:</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="registros.length > 0">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div
              v-show="nombreBodega != null && nombreBodega != ''"
              class="form-field"
            >
              <h6>{{ `SUCURSAL: ${nombreBodega}` }}</h6>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="table-responsive">
              <table class="table--bordered">
                <thead>
                  <tr>
                    <th
                      colspan="2"
                      style="font-size: 10px; background-color: #f3f2f2"
                    >
                      DIAS DE LA SEMANA
                    </th>
                    <th
                      style="font-size: 11px; background-color: #f3f2f2"
                      :colspan="agruparSemanal ? '3' : '4'"
                      v-for="(fecha, index) in fechas"
                      :key="
                        index.toString() +
                        moment(new Date()).format('YYYYMMDDHHmmss') +
                        'fecha'
                      "
                    >
                      <span>{{
                        fecha.fecha_pedido + " " + fecha.dia_semana
                      }}</span>
                    </th>
                    <th
                      rowspan="2"
                      style="font-size: 11px; background-color: #e8e7e7"
                    >
                      <b>TOTAL ACTIVAS</b>
                    </th>
                    <th
                      rowspan="2"
                      style="font-size: 11px; background-color: #e8e7e7"
                    >
                      <b>TOTAL NUEVAS</b>
                    </th>
                    <th
                      rowspan="2"
                      style="font-size: 11px; background-color: #e8e7e7"
                      v-show="!agruparSemanal"
                    >
                      <b>TOTAL SUPERV.</b>
                    </th>
                    <th
                      rowspan="2"
                      style="font-size: 11px; background-color: #e8e7e7"
                    >
                      <b>TOTAL TARJETAS</b>
                    </th>
                  </tr>
                  <tr>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      #
                    </th>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      RUTA
                    </th>
                    <th
                      style="font-size: 10px; background-color: #e8e7e7"
                      v-for="(indiceFecha, index2) in indicesFechasX2"
                      :key="
                        index2.toString() +
                        moment(new Date()).format('YYYYMMDDHHmmss') +
                        'activas'
                      "
                    >
                      <span v-show="indiceFecha.tipo == 'A'">ACTIVAS</span>
                      <span v-show="indiceFecha.tipo == 'N'">NUEVAS</span>
                      <span v-show="indiceFecha.tipo == 'S'">SUPERV.</span>
                      <span v-show="indiceFecha.tipo == 'T'">TOTAL</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(registro, index3) in registros"
                    :key="
                      index3.toString() +
                      moment(new Date()).format('YYYYMMDDHHmmss') +
                      'reg'
                    "
                  >
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{ index3 + 1 }}</b>
                    </td>
                    <td style="font-size: 10px">
                      {{ registro.ruta_nombre }}
                    </td>
                    <td
                      style="font-size: 10px"
                      v-for="(indiceRegistro, index4) in indicesRegistrosX2"
                      :key="
                        index4.toString() +
                        moment(new Date()).format('YYYYMMDDHHmmss') +
                        'detalle'
                      "
                    >
                      <span v-show="indiceRegistro.tipo == 'A'">
                        {{
                          formatear(
                            registro.detalles[indiceRegistro.i].cantidad_activas
                          )
                        }}
                      </span>
                      <span v-show="indiceRegistro.tipo == 'N'">
                        {{
                          formatear(
                            registro.detalles[indiceRegistro.i].cantidad_nuevas
                          )
                        }}
                      </span>
                      <span v-show="indiceRegistro.tipo == 'S'">
                        {{
                          formatear(
                            registro.detalles[indiceRegistro.i].cantidad_supervisadas
                          )
                        }}
                      </span>
                      <span v-show="indiceRegistro.tipo == 'T'">
                        {{
                          formatear(
                            registro.detalles[indiceRegistro.i].cantidad_activas,
                            registro.detalles[indiceRegistro.i].cantidad_nuevas,
                            registro.detalles[indiceRegistro.i].cantidad_supervisadas
                          )
                        }}
                      </span>
                    </td>
                    <td style="font-size: 10px">
                      <b>{{ formatear(registro.total_activas) }}</b>
                    </td>
                    <td style="font-size: 10px">
                      <b>{{ formatear(registro.total_nuevas) }}</b>
                    </td>
                    <td style="font-size: 10px" v-show="!agruparSemanal">
                      <b>{{ formatear(registro.total_supervisadas) }}</b>
                    </td>
                    <td style="font-size: 10px">
                      <b>{{
                        formatear(
                          registro.total_nuevas,
                          registro.total_activas,
                          registro.total_supervisadas
                        )
                      }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>*</b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>TOTAL</b>
                    </td>
                    <td
                      style="font-size: 10px; background-color: #f3f2f2"
                      v-for="(indiceRegistro, index4) in indicesRegistrosX2"
                      :key="
                        index4.toString() +
                        moment(new Date()).format('YYYYMMDDHHmmss') +
                        'detalle'
                      "
                    >
                      <b v-show="indiceRegistro.tipo == 'A'">
                        {{
                          formatear(
                            fechasTotales[indiceRegistro.i].cantidad_activas
                          )
                        }}
                      </b>
                      <b v-show="indiceRegistro.tipo == 'N'">
                        {{
                          formatear(
                            fechasTotales[indiceRegistro.i].cantidad_nuevas
                          )
                        }}
                      </b>
                      <b v-show="indiceRegistro.tipo == 'S'">
                        {{
                          formatear(
                            fechasTotales[indiceRegistro.i]
                              .cantidad_supervisadas
                          )
                        }}
                      </b>
                      <b v-show="indiceRegistro.tipo == 'T'">
                        {{
                          formatear(
                            fechasTotales[indiceRegistro.i].cantidad_activas,
                            fechasTotales[indiceRegistro.i].cantidad_nuevas,
                            fechasTotales[indiceRegistro.i]
                              .cantidad_supervisadas
                          )
                        }}
                      </b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{ formatear(totalActivas) }}</b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{ formatear(totalNuevas) }}</b>
                    </td>
                    <td
                      style="font-size: 10px; background-color: #f3f2f2"
                      v-show="!agruparSemanal"
                    >
                      <b>{{ formatear(totalSupervisadas) }}</b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{
                        formatear(totalActivas, totalNuevas, totalSupervisadas)
                      }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      name="historicos"
      height="auto"
      width="70%"
      scrollable
      adaptive
      resizable
      reset
    >
      <reportes-historicos-excel
        tipoReporte='ct'
      ></reportes-historicos-excel>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    bodegas: {
      required: true,
    },
    administraTodasBodegas: {
      type: Boolean,
      required: true,
    },
    idBodegaUsuario: {
      required: true,
    },
  },
  data: function () {
    return {
      moment: moment,
      moneyFormat: moneyFormat,
      totalNuevas: 0,
      totalActivas: 0,
      totalSupervisadas: 0,
      indicesFechasX2: [],
      indicesRegistrosX2: [],
      fechas: [],
      fechasTotales: [],
      registros: [],
      selectedRutas: [],
      optionsRutas: [],
      selectedBodega: null,
      nombreBodega: "",
      tipoValoresConsultado: "C",
      agruparSemanal: false,
      optionsBodegas: [],
      form: {
        tipoFecha: "P",
        fechaDesde: "",
        fechaHasta: "",
        idsRutas: [],
        idBodega: null,
        tipoValores: "C",
        cantidadDias: 1,
      },
    };
  },
  methods: {
    onSearchRutas: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.optionsRutas = json;
          loading(false);
        } else loading(false);
      };
      let urlApi = `${url}/search/rutas?search=${search}`;
      xmlhttp.open("GET", urlApi, true);
      xmlhttp.send();
    },
    inputRutas: function () {
      this.form.idsRutas.splice(0, this.form.idsRutas.length);
      this.form.idsRutas = this.selectedRutas.map(
        ruta => ruta.id
      );
    },
    inputBodega: function () {
      this.form.idBodega = null;
      if (this.selectedBodega != null)
        this.form.idBodega = this.selectedBodega.id;
    },
    validandoFiltros: function () {
      //Validando las fechas
      this.cantidadDias = 1;
      if (this.form.tipoFecha == "P") {
        if (this.form.fechaDesde == null || this.form.fechaHasta == null) {
          swal("Aviso", "Las fechas son requeridas", "warning");
          return false;
        }
        let desde = new Date(this.form.fechaDesde + " 00:00:00");
        let hasta = new Date(this.form.fechaHasta + " 00:00:00");
        if (desde == "Invalid Date" || hasta == "Invalid Date") {
          swal("Aviso", "Debe ingresar correctamente las fechas", "warning");
          return false;
        } else {
          desde = moment(desde);
          hasta = moment(hasta);
          let diferencia = parseInt(hasta.diff(desde, "days"));
          this.cantidadDias = diferencia + 1;
        }
      }
      return true;
    },
    exportarDocumento: function (tipo) {
      if (!this.validandoFiltros()) return;
      let urlApi = `${url}/reporte-cuadre-tarjeta/consultar/${tipo}${this.serialize(
        this.form
      )}`;
      window.open(urlApi, "_blank");
    },
    consultar: function () {
      if (!this.validandoFiltros()) return;
      let urlApi = `${url}/reporte-cuadre-tarjeta/consultar/C`;
      axios
        .post(urlApi, this.form)
        .then((response) => {
          this.agruparSemanal = response.data.agruparSemanal;
          this.tipoValoresConsultado = response.data.tipoValores;
          this.nombreBodega = response.data.nombreBodega;
          this.totalActivas = response.data.totalActivas;
          this.totalNuevas = response.data.totalNuevas;
          this.totalSupervisadas = response.data.totalSupervisadas;
          this.fechas.splice(0, this.fechas.length);
          this.fechas = [...response.data.fechas];
          this.fechasTotales.splice(0, this.fechasTotales.length);
          this.fechasTotales = [...response.data.fechasTotales];
          this.indicesFechasX2.splice(0, this.indicesFechasX2.length);
          for (let i = 1; i <= this.fechas.length; i++) {
            this.indicesFechasX2.push({ i: i, tipo: "A" }); //Activos
            this.indicesFechasX2.push({ i: i, tipo: "N" }); //Nuevos
            if (!this.agruparSemanal)
              this.indicesFechasX2.push({ i: i, tipo: "S" }); //Supervisadas
            this.indicesFechasX2.push({ i: i, tipo: "T" });
          }
          this.indicesRegistrosX2.splice(0, this.indicesRegistrosX2.length);
          for (let i = 0; i < this.fechas.length; i++) {
            this.indicesRegistrosX2.push({ i: i, tipo: "A" }); //Activos
            this.indicesRegistrosX2.push({ i: i, tipo: "N" }); //Nuevos
            if (!this.agruparSemanal)
              this.indicesRegistrosX2.push({ i: i, tipo: "S" }); //Supervisadas
            this.indicesRegistrosX2.push({ i: i, tipo: "T" });            
          }
          this.registros.splice(0, this.registros.length);
          this.registros = [...response.data.registros];
        })
        .catch((error) => {
          swal("Error", "No se pudo consultar el reporte", "error");
        });
    },
    mostrarHistoricos: function () {
      this.$modal.show('historicos');
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    formatear: function (valor, valor2 = 0, valor3 = 0) {
      return this.tipoValoresConsultado == "C"
        ? parseInt(valor) + parseInt(valor2) + parseInt(valor3)
        : moneyFormat(
            parseFloat(valor) + parseFloat(valor2) + parseFloat(valor3)
          );
    },
  },
  mounted: function () {
    //Seteando fechas por defecto
    let desde = new Date();
    desde.setDate(desde.getDate() - 6);
    let hasta = new Date();
    this.form.fechaDesde = moment(desde).format("YYYY-MM-DD");
    this.form.fechaHasta = moment(hasta).format("YYYY-MM-DD");
    //Seteando bodegas
    if (this.administraTodasBodegas) this.optionsBodegas = [...this.bodegas];
    else {
      for (let i = 0; i < this.bodegas.length; i++) {
        if (this.idBodegaUsuario == this.bodegas[i].id) {
          this.optionsBodegas.push(this.bodegas[i]);
          this.selectedBodega = this.bodegas[i];
          this.form.idBodega = this.bodegas[i].id;
          break;
        }
      }
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ReporteCuadreTarjeta.vue